import { Button, Checkbox, FormControlLabel, FormGroup, Grid, Link, Stack, Typography } from '@mui/material'
import axios from 'axios';
import React, { useCallback, useState } from 'react'
import ImageViewer from 'react-simple-image-viewer';
import { ClipLoader } from 'react-spinners';
import { useLoading } from '../shared/hooks/useLoading';
import { IBreachDetails } from './models/breach-details.interface'
import { IPaymentResponse } from './models/payment-response.interface';

interface IProps {
  details: IBreachDetails
}

export const BreachDetails: React.FC<IProps> = (props: IProps) => {
  const { details } = props
  const [currentImage, setCurrentImage] = useState(0);
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [paymentError, setPaymentError] = useState<string>('')
  const [checked, setChecked] = useState(false);
  const { loading, setLoading } = useLoading()
  const amount = parseFloat(details.amount)

  const openImageViewer = useCallback((index: number) => {
    setCurrentImage(index);
    setIsViewerOpen(true);
  }, []);

  const closeImageViewer = () => {
    setCurrentImage(0);
    setIsViewerOpen(false);
  };

  const payTicket = async () => {
    setLoading(true)
    const response = await axios.post<IPaymentResponse>(`${process.env.REACT_APP_API_URL}/payment`, {
      amount: details.amount,
      ticketNbr: details.ticketNbr,
      vrm: details.vrm,
      siteName: details.location,
    })
    const { data: paymentResponse } = response
    if (paymentResponse.error && paymentResponse.message) {
      setPaymentError(paymentResponse.message)
      setLoading(false)
    } else {
      window.open(paymentResponse.redirectUrl, '_self', 'noopener,noreferrer')
    }
  }

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    console.log('Checked', event.target.checked)
    setChecked(event.target.checked);
  };

  const payDisabled = !checked || loading || !amount
  console.log('Paydisabled', payDisabled)

  return (
    <Grid container>
      <Grid item sm={8} xs={12}>
        <Stack spacing={1}>
          <Grid container>
            <Grid item xs={6}>
              <Typography variant='body1' fontWeight='bold'>Breach ID</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant='body1'>{details.ticketNbr}</Typography>
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={6}>
              <Typography variant='body1' fontWeight='bold'>Car Rego</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant='body1'>{details.vrm}</Typography>
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={6}>
              <Typography variant='body1' fontWeight='bold'>Make</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant='body1'>{details.make}</Typography>
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={6}>
              <Typography variant='body1' fontWeight='bold'>Model</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant='body1'>{details.model}</Typography>
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={6}>
              <Typography variant='body1' fontWeight='bold'>Colour</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant='body1'>{details.color}</Typography>
            </Grid>
          </Grid>
          <Typography variant='body1'>
            Our records show that the above vehicle has parked in breach of the car park’s terms and conditions, resulting in the following Breach Notice:
          </Typography>
          <Stack spacing={1}>
            <Typography variant='body1' fontWeight='bold'>Breach Details</Typography>
            <Typography variant='body1'>{details.details}</Typography>
            <Typography variant='body1' fontWeight='bold'>Car Park Location</Typography>
            <Typography variant='body1'>{details.location}</Typography>
            <Typography variant='body1' fontWeight='bold'>Date of Breach Issue</Typography>
            <Typography variant='body1'>{details.timeIn}</Typography>
            <Typography variant='body1' fontWeight='bold'>Offence Date</Typography>
            <Typography variant='body1'>{details.offenceTime}</Typography>
            <Typography variant='body1' fontWeight='bold'>Amount</Typography>
            <Typography variant='body1'>NZD$ {details.amount}</Typography>
            <Typography variant='body1'>
              Please note that use of Breach Look Up and Payment Function confirms
              your acceptance of our Website Terms and Privacy Policies - <Link href='https://cpadmin.squarespace.com/website-terms'>View Terms</Link>
            </Typography>
            <FormGroup>
              <FormControlLabel control={<Checkbox
                checked={checked}
                onChange={handleChange}
                inputProps={{ 'aria-label': 'controlled' }}
              />} label="I accept the terms" />
            </FormGroup>
            {
              paymentError && <Typography variant='body1' color='red'>{paymentError}</Typography>
            }
            <Stack direction={'row'} spacing={1}>
              <Button variant="contained" type="button"
                disabled={payDisabled}
                onClick={payTicket}>{amount ? 'Pay' : 'Nothing to pay'}</Button>
              <ClipLoader loading={loading} />
            </Stack>
          </Stack>
        </Stack>
      </Grid>
      <Grid item sm={4} xs={12}>
        <Stack spacing={1}>
          <Typography variant='body1' fontWeight='bold'>Photographic Evidence</Typography>
          {
            details.images.map((image, index) => (
              <img key={image} src={image}
                alt={image} onClick={() => openImageViewer(index)} />
            ))
          }
        </Stack>
        {isViewerOpen && (
          <ImageViewer
            src={details.images}
            currentIndex={currentImage}
            disableScroll={true}
            closeOnClickOutside={true}
            onClose={closeImageViewer}
          />
        )}
      </Grid>
    </Grid>
  )
}